export const amountAsText: (amount: number) => string = amount => {
  let decimal = String(amount % 100);
  if (decimal.length < 2) {
    decimal += '0';
  }
  const number = Math.floor(amount / 100);
  return `${number},${decimal}`;
};
